import React, { FC, useState } from 'react'
import { useStore } from 'react-redux'
import { ServiceUserType } from 'models/ServiceUsersTypes'
import {
  InputEditorButton,
  InputEditorContainer,
  InputEditorHolder,
  InputEditorInput
} from './InputEditor.styles'
import { createServiceUser, getServiceUsers } from '../../api/serviceUsersApi'

interface Props {
  user: ServiceUserType
  value: string
  userKey: string
  botId: string
}

export const InputEditor: FC<Props> = ({
  user,
  value,
  userKey,
  botId
}) => {
  const store = useStore()
  const { professionalsTab: { currentPage } } = store.getState()
  const [isInputOpen, setIsInputOpen] = useState(false)
  const [inputValue, setInputValue] = useState(value)

  const onChangeHandler = (e) => {
    const value = e.target.value
    setInputValue(value)
  }

  const onBlurHandler = () => {
    if (value !== inputValue) {
      const userData = {
        ...user,
        [userKey]: inputValue
      }
      createServiceUser(botId, userData).then(() => {
        getServiceUsers(botId, currentPage)
      })
    }
    setIsInputOpen(false)
  }

  return (
    <InputEditorContainer>
      {isInputOpen ? (
        <InputEditorHolder>
          <InputEditorInput
            type='text'
            data-autotest={'atom-name-input'}
            onBlur={onBlurHandler}
            onChange={onChangeHandler}
            value={inputValue}
            autoFocus
            maxLength={30}
          />
        </InputEditorHolder>
      ) : (
        <InputEditorButton
          onClick={() => {
            setInputValue(value)
            setIsInputOpen(true)
          }}
        >
          {value}
        </InputEditorButton>
      )}
    </InputEditorContainer>
  )
}
